import { EntityNotesEditor } from '@/components/entities/entity-notes-editor';
import React from 'react';

interface EntityNotesTabProps {
  entityId: string | number;
}

/**
 * Minimal, distraction-free notes & lore editor tab
 */
export const EntityNotesTab: React.FC<EntityNotesTabProps> = ({ entityId }) => {
  return (
    <div className="pt-2">
      <EntityNotesEditor entityId={entityId} />
    </div>
  );
};

export default EntityNotesTab;
